// extracted by mini-css-extract-plugin
export default {"contacts":"contacts_contacts__rQgxj","contacts__text":"contacts_contacts__text__WO65H","contacts__email":"contacts_contacts__email__RYtiZ"};